import React from 'react';
import SectionCard from './SectionCard';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';

const RemindersSection = ({ submission, isDark }) => {
    if (submission.recipient_source === 'non-strata') {
        return null;
    }

    return (
        <SectionCard isDark={isDark}>
            <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>Do you wish to send reminders?</p>
            {submission.sendReminders && (
                <RadioGroup value={submission.sendReminders}>
                    <div className='flex flex-col gap-[14px]'>
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value={submission.sendReminders} id={`sendReminders-${submission.sendReminders}`} />
                            <label htmlFor={`sendReminders-${submission.sendReminders}`} className={`text-[16px] m-0 cursor-default capitalize transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>{submission.sendReminders}</label>
                        </div>
                    </div>
                </RadioGroup>
            )}

            {/* Reminder Date */}
            {submission.sendReminders == 'yes' && (
                <div className='flex flex-col gap-[8px]'>
                    <input
                        className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                            isDark
                                ? 'bg-[#161515]  text-white'
                                : 'bg-[#f5f5f5] text-[#072837]'
                        }`}
                        type="text"
                    value={submission.reminderDate?(new Intl.DateTimeFormat('en-GB', {
                        day:'2-digit', month:'2-digit', year:'numeric',
                        hour:'2-digit', minute:'2-digit', hour12:true, timeZone:'UTC'
                      }).format(new Date(submission.reminderDate)).replace(' ',' ').toLowerCase()):''}
                        readOnly
                    />
                </div>
            )}
        </SectionCard>
    );
};

export default RemindersSection;
